import { FlowPartType, FlowNodeTypeEnum } from '$/domains/node/type';
import { PortItem } from '$/domains/mcp/type';

// 根据节点类型获取输出端口类型
export function getPortType(nodeType: string): FlowPartType | undefined {
  if (nodeType.includes('TEXT')) {
    return FlowPartType.TEXT;
  }
  if (nodeType.includes('IMAGE')) {
    return FlowPartType.IMAGE;
  }
  if (nodeType.includes('VIDEO')) {
    return FlowPartType.VIDEO;
  }
  if (nodeType.includes('AUDIO')) {
    return FlowPartType.AUDIO;
  }
  return undefined;
}

export const portOrder = {
  TEXT: 0, AUDIO: 1, IMAGE: 2, VIDEO: 3, GIF: 4,
};
export const getSortedInputPortList = (inputPortConfig: Array<PortItem>) => {
  return [...inputPortConfig].sort((a, b) => {
    return (portOrder[a.sourcePortType]) - (portOrder[b.sourcePortType]);
  });
};

export const getOutputPortId = (flowNodeType: FlowNodeTypeEnum | string, nodeId: string) => {
  return `port-output-${getPortType(flowNodeType)}-${nodeId}`;
};

/**
 *
 * @param nodeId 节点id
 * @param sourcePortType 来源port类型
 * @param portIndex 当前编辑节点所有输入端口的排序索引（现根据端口名后根据端口类型）
 * @param i 同类型第几个（或者同portName第几个）
 * @returns
 */
export const getInputPortId = (nodeId: string, sourcePortType: FlowPartType, portIndex: number, i: number) => {
  return `port-input-${nodeId}-${sourcePortType}-${portIndex}-${i}`;
};
